export default __webpack_public_path__ + "static/media/active-category.8ab8c727.svg";